import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { emitEvent } from '@/utils/eventBus';
const base = `${import.meta.env.VITE_STRAPI_URL ?? 'http://localhost:1337'}/api`;
export async function rightToWorkRequest(supplierId, path = '', { method = 'get', data } = {}) {
  const auth = useAuthStore();
  try {
    const response = await axios({ url: `${base}/catalog-items/${encodeURIComponent(supplierId)}/right-to-work${path}`, method, data, headers: auth.token ? auth.requestHeaders.headers : {} });
    if (method !== 'get') emitEvent('catalog:changed', { catalogName: 'suppliers' });
    return response.data.data;
  } catch (error) {
    error.message = error.response?.data?.error?.message || error.message;
    throw error;
  }
}
export async function exportMigrationReview() {
  const auth = useAuthStore();
  const response = await axios.get(`${base}/right-to-work/migration-review`, { headers: auth.token ? auth.requestHeaders.headers : {} });
  return response.data.data;
}
export function downloadAudit(data, filename) {
  const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }));
  const link = document.createElement('a'); link.href = url; link.download = filename; link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
